module.exports = __webpack_public_path__ + "static/img/operaing.1ea78b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaing.png
// module id = 9IUK
// module chunks = 1